import { z } from 'zod';
import { PriceSchema, VoucherBaseSchema } from './Common.schema';

const OrderVoucherRefundSchema = z.object({
  createdAt: z.string(),
  uuid: z.string(),
  refundValue: PriceSchema,
  reason: z.string(),
});

export const OrderVoucherBaseSchema = VoucherBaseSchema.extend({
  refunds: z.array(OrderVoucherRefundSchema),
});

export const ExperienceOrderVoucherSchema = OrderVoucherBaseSchema.extend({
  orderItem: z.union([z.number(), z.string()]),
});
export const MonetaryOrderVoucherSchema = OrderVoucherBaseSchema;

export const OrderVoucherSchema = z.union([
  ExperienceOrderVoucherSchema,
  MonetaryOrderVoucherSchema,
]);
